export const TEST_IDS = {
    // Layout
    navHome: "nav-home-link",
    navExplore: "nav-explore-link",
    navSubmit: "nav-submit-link",
    navSearchInput: "nav-search-input",
    navSearchButton: "nav-search-button",
    themeBrand: "sdx-brand",
    // Dashboard
    dashboardHero: "dashboard-hero",
    statTotalDatasets: "stat-total-datasets",
    statTotalCountries: "stat-total-countries",
    statTotalMaterials: "stat-total-materials",
    statVerified: "stat-verified-pct",
    statContributors: "stat-contributors",
    statParameters: "stat-parameters",
    statUnderReview: "stat-under-review",
    statMissing: "stat-missing",
    trendingCategoryCard: "trending-category-card",
    topMaterialCard: "top-material-card",
    topOrgCard: "top-org-card",
    recentUpdateCard: "recent-update-card",
    dashboardExploreCta: "dashboard-explore-cta",
    dashboardSubmitCta: "dashboard-submit-cta",
    // Explorer
    hierarchyPanel: "hierarchy-panel",
    countryNode: "country-node",
    continentNode: "continent-node",
    categoryNode: "category-node",
    materialNode: "material-node",
    materialTypeNode: "material-type-node",
    processNode: "process-node",
    detailPanel: "detail-panel",
    breadcrumb: "breadcrumb",
    emptyState: "empty-state",
    processEmptyState: "process-empty-state",
    contributeCta: "contribute-cta",
    // Parameter list (process view)
    parameterList: "parameter-list",
    parameterConceptCard: "parameter-concept-card",
    parameterMissingCard: "parameter-missing-card",
    // Parameter detail (community datasets view)
    parameterDetail: "parameter-detail",
    parameterOverview: "parameter-overview",
    parameterSummaryCard: "parameter-summary-card",
    consensusPanel: "consensus-panel",
    distributionChart: "distribution-chart",
    sortDropdown: "sort-dropdown",
    filterPanel: "filter-panel",
    filterOrgType: "filter-org-type",
    filterStatus: "filter-status",
    filterPeerReviewed: "filter-peer-reviewed",
    filterMinConfidence: "filter-min-confidence",
    filterClear: "filter-clear",
    // Community dataset cards
    communityDatasetCard: "community-dataset-card",
    communityDatasetValue: "community-dataset-value",
    communityDatasetOrg: "community-dataset-org",
    communityDatasetStatus: "community-dataset-status",
    communityDatasetExpand: "community-dataset-expand",
    communityDatasetCompareCheckbox: "community-dataset-compare-checkbox",
    // Comparison
    comparisonBar: "comparison-bar",
    comparisonOpen: "comparison-open",
    comparisonModal: "comparison-modal",
    comparisonTable: "comparison-table",
    comparisonClose: "comparison-close",
    // Community: votes + comments (nested inside CommunityDatasetCard)
    validationWidget: "validation-widget",
    voteAgreeButton: "vote-agree-button",
    voteDisagreeButton: "vote-disagree-button",
    voteAgreeCount: "vote-agree-count",
    voteDisagreeCount: "vote-disagree-count",
    userVoteIndicator: "user-vote-indicator",
    commentList: "comment-list",
    commentInput: "comment-input",
    commentSubmit: "comment-submit",
    // Version
    versionHistory: "version-history",
    versionEntry: "version-entry",
    // Submit / Wizard
    submitForm: "submit-form",
    submitStep: "submit-step",
    submitName: "submit-name-input",
    submitEmail: "submit-email-input",
    submitPath: "submit-path-input",
    submitUrl: "submit-url-input",
    submitDoi: "submit-doi-input",
    submitNotes: "submit-notes-input",
    submitSourceType: "submit-source-type",
    submitPreviewCard: "submit-preview-card",
    submitDuplicateWarning: "submit-duplicate-warning",
    submitButton: "submit-submit-button",
    submitSuccess: "submit-success-toast",
    wizardStepIndicator: "wizard-step-indicator",
    wizardBreadcrumb: "wizard-breadcrumb",
    wizardBackButton: "wizard-back",
    wizardNextButton: "wizard-next",
    wizardDropdown: "wizard-dropdown",
    wizardDropdownOption: "wizard-dropdown-option",
    wizardDropdownSearch: "wizard-dropdown-search",
    wizardAddNew: "wizard-add-new",
    wizardAddNewInput: "wizard-add-new-input",
    wizardAddNewConfirm: "wizard-add-new-confirm",
    wizardValueInput: "wizard-value-input",
    wizardUnitInput: "wizard-unit-input",
    wizardOrgName: "wizard-org-name",
    wizardOrgType: "wizard-org-type",
    wizardSourceUrl: "wizard-source-url",
    wizardReviewSubmit: "wizard-review-submit",
    wizardDuplicateModal: "wizard-duplicate-modal",
    wizardDuplicateContinue: "wizard-duplicate-continue",
    wizardDuplicateCancel: "wizard-duplicate-cancel",
    wizardSuccessScreen: "wizard-success-screen",
    // Admin
    adminLoginForm: "admin-login-form",
    adminEmailInput: "admin-email-input",
    adminPasswordInput: "admin-password-input",
    adminLoginButton: "admin-login-button",
    adminNavLink: "admin-nav-link",
    adminLogoutButton: "admin-logout-button",
    adminPendingCard: "admin-pending-card",
    adminApproveButton: "admin-approve-button",
    adminRejectButton: "admin-reject-button",
    adminApproveAllButton: "admin-approve-all-button",
    adminPendingSection: "admin-pending-section",
    // Organization profile popover
    orgProfilePopover: "org-profile-popover",
};
